import Arbor from '../../arbor'
import { ActivePage } from '../../enums/ActivePage'
import State from './State'

let preloadCache

const ThankYouController = new class {

    async preload() {

        if (typeof preloadCache !== 'undefined') {
            return true
        }

        preloadCache = await fetch(appendQuery(`/fast/thank-you/${ Arbor.store('state').visitorId }`))
            .then(response => response.json())
            .then(data => data.data.view)

        return true

    }

    async start() {

        await this.preload()
        State.content = preloadCache
        preloadCache = undefined
        Arbor.store('qv').navigation.activePage = ActivePage.ThankYou
        Arbor.store('qv').navigation.goToThankYouPage()

    }

    async confirm(thankYouPageId, ruleId) {

        /*
         * RuleId may be null when using preview links, which load the TYP
         * directly without going through the TYP rule matcher
         */
        const url = ruleId
            ? `/thank-you/${ Arbor.store('state').visitorId }/${ thankYouPageId }/confirm/${ ruleId }`
            : `/thank-you/${ Arbor.store('state').visitorId }/${ thankYouPageId }/confirm`

        await fetch(url, {
            method: 'POST',
            headers: {
                'content-type': 'application/json',
                'x-csrf-token': Arbor.store('qv').getCsrfToken(),
            },
        })

    }

    async rotate() {

        await fetch(appendQuery(`/fast/thank-you/${ Arbor.store('state').visitorId }/rotate`))
            .then(response => response.json())
            .then(data => {

                if (data.data && typeof data.data.view !== 'undefined') {
                    State.content = data.data.view
                }

            })

    }

    async updateLeadData(data) {

        await fetch(`/update-lead-data/${ Arbor.store('state').visitorId }`, {
            method: 'POST',
            headers: {
                'content-type': 'application/json',
                'x-csrf-token': Arbor.store('qv').getCsrfToken(),
            },
            body: JSON.stringify(data),
        })

    }

}()

function appendQuery(path) {
    return Arbor.store('qv').helpers.appendQuery(path)
}

export default ThankYouController
